import React, { useEffect } from "react";

import { AccordionRoot, AccordionRootProps } from "@packages/ds";

import { sendPendoEventAccordion } from "Store/analytics/pendoFunctions";

export type TrackedAccordionRootProps = AccordionRootProps & {
  /**
   * Analytics ID for tracking (optional)
   */
  analyticId?: string;
};

/**
 * Accordion root with analytics tracking
 */
export const TrackedAccordionRoot = (props: TrackedAccordionRootProps) => {
  const { value, analyticId, onValueChange, type, ...restProps } = props;

  useEffect(() => {
    if (value) {
      const analyticsValue = Array.isArray(value) ? value.join(",") : value;
      sendPendoEventAccordion(analyticsValue);
    }
  }, [value]);

  const handleValueChange = (newValue: any) => {
    if (analyticId) {
      sendPendoEventAccordion(analyticId);
    }
    onValueChange?.(newValue);
  };

  // Create a component based on accordion type
  if (type === "single") {
    // For single type
    return (
      <AccordionRoot
        type="single"
        {...(restProps as any)}
        value={value as string}
        onValueChange={handleValueChange as any}
      />
    );
  } else {
    // For multiple type
    return (
      <AccordionRoot
        type="multiple"
        {...(restProps as any)}
        value={value as string[]}
        onValueChange={handleValueChange as any}
      />
    );
  }
};
